import Icon from '@material-ui/icons/AccessibilityNew';
import PhysicalList from './PhysicalList';
import Edit from './PhysicalEdit';
import Create from './PhysicalCreate';
import View from './PhysicalView'

export default {
    list: PhysicalList,
    show: View,
    edit: Edit,
    create: Create,
    icon: Icon,
};

